import React, { FC, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FormNodeType } from '../../../../shared/kiosk';
import { useTranslation } from '../../../translations';
import { nodeEditors } from './elements';

interface EditModalProps {
  readonly name: string;
  readonly node: FormNodeType;
  readonly onSave: (node: FormNodeType) => void;
  readonly onCancel: () => void;
}

export const EditModal: FC<EditModalProps> = ({ name, node: initialValue, onSave, onCancel }) => {
  const { ts } = useTranslation();
  const [node, setNode] = useState(initialValue);
  const editor = nodeEditors[node.type];

  return (
    <Modal className="modal-large" id="editorModal" isOpen>
      <ModalHeader>
        Update node: {node.displayName ? `${node.displayName} (${name})` : name}
      </ModalHeader>
      <ModalBody>{editor.getUpdateForm!({ node, update: setNode, ts })}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel}>
          {ts('common.cancel')}
        </Button>{' '}
        <Button
          color="primary"
          id="saveModal"
          onClick={() => {
            onSave(node);
          }}
        >
          {ts('common.save')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
